const DEFAULT_DEMO_ORIGIN = 'https://agents.interactivetalker.com';

const ENV_TOKENS: Record<string, string | undefined> = {
  turismo: import.meta.env.VITE_DEMO_TOKEN_TURISMO,
  circula: import.meta.env.VITE_DEMO_TOKEN_CIRCULA,
  telco: import.meta.env.VITE_DEMO_TOKEN_TELCO,
  salud: import.meta.env.VITE_DEMO_TOKEN_SALUD,
  educacion: import.meta.env.VITE_DEMO_TOKEN_EDUCACION,
  ventas: import.meta.env.VITE_DEMO_TOKEN_VENTAS,
  cobranza: import.meta.env.VITE_DEMO_TOKEN_COBRANZA,
  logistica: import.meta.env.VITE_DEMO_TOKEN_LOGISTICA,
  atencion: import.meta.env.VITE_DEMO_TOKEN_ATENCION,
};

export function demoWebOrigin(): string {
  return (import.meta.env.VITE_DEMO_ORIGIN?.trim() || DEFAULT_DEMO_ORIGIN).replace(/\/$/, '');
}

export function resolveDemoToken(useCaseId: string, configured: string | null): string | null {
  const fromEnv = ENV_TOKENS[useCaseId]?.trim();
  if (fromEnv) return fromEnv;
  return configured?.trim() || null;
}

export function demoWebUrl(useCaseId: string, configured: string | null): string | null {
  const token = resolveDemoToken(useCaseId, configured);
  if (!token) return null;
  return `${demoWebOrigin()}/demo/${token}?from=landing`;
}
